import ConfidenceCommunication from '~/pages/communication/confidence/libs/components/ConfidenceCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const ConfidenceCommunicationPage = (props: TPageProps) => (
  <ConfidenceCommunication {...props} />
)

export default ConfidenceCommunicationPage
